<template>
  <v-sheet height="100vh" class="alternate-links">
    <LoadingWidget v-if="loading" />
  </v-sheet>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
const _config = {
  mod: "alternate-links",
};

export default {
  data: () => ({
    loading: false,
  }),
  computed: {
    itemId() {
      return this.$route.params.itemId.replace(/^.*-([0-9]+)$/, "$1");
    },
  },
  methods: {
    redirect() {
      this.loading = true;
      this.$rest(_config.mod)
        .get({ id: this.itemId })
        .then((item) => {
          location.href = item.link;
        })
        .catch(() => {
          this.loading = false;
          this.$router.push("/erro404");
        })
        .finally(() => (this.loading = false));
    },
  },
  mounted() {
    this.redirect();
  },
  components: { LoadingWidget },
};
</script>

<style lang="scss"></style>
